import { useStore } from '@/store'

const store = useStore()

function updateLabel(el, label) {
  if (el.__ph2FilterButton) {
    el.__ph2FilterButton.querySelector('span').textContent = label
  }
}

export const ph2MobileFilters = {
  mounted(el, binding) {
    if (store.state.user.siteCode !== 'PH2') {
      return
    }

    const button = document.createElement('button')
    const label = document.createElement('span')
    const icon = document.createElement('span')

    button.type = 'button'
    button.className = 'ph2-mobile-filter-toggle'
    button.setAttribute('aria-expanded', 'false')
    label.textContent = binding.value
    icon.className = 'ph2-mobile-filter-chevron'
    icon.setAttribute('aria-hidden', 'true')
    button.append(label, icon)

    el.classList.add('ph2-mobile-filter-content', 'is-collapsed')
    el.parentNode.insertBefore(button, el)

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true'
      button.setAttribute('aria-expanded', String(!expanded))
      button.classList.toggle('is-expanded', !expanded)
      el.classList.toggle('is-collapsed', expanded)
    })

    el.__ph2FilterButton = button
  },
  updated(el, binding) {
    updateLabel(el, binding.value)
  },
  unmounted(el) {
    el.__ph2FilterButton?.remove()
    delete el.__ph2FilterButton
  },
}
